/**
 * Generic table.
 * columns: [{ key, header, align?, render?(row) }]
 * rows: array of objects
 * states: loading, error (string), empty (node) for the no-rows invitation
 */
const SKEL_W = ['68%', '46%', '58%', '40%', '52%', '44%', '60%'];

export default function DataTable({ columns, rows, loading, error, empty, getRowKey, onRowClick, skeletonRows = 6 }) {
  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key} className={c.align === 'right' ? 'is-right' : undefined}>
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading &&
            Array.from({ length: skeletonRows }).map((_, r) => (
              <tr key={`skel-${r}`} className="table__skel" aria-hidden="true">
                {columns.map((c, ci) => (
                  <td key={c.key} className={c.align === 'right' ? 'is-right' : undefined}>
                    <span className="skel" style={{ width: c.align === 'right' ? '40%' : SKEL_W[(ci + r) % SKEL_W.length] }} />
                  </td>
                ))}
              </tr>
            ))}

          {!loading && error && (
            <tr className="table__state table__state--error">
              <td colSpan={columns.length}>{error}</td>
            </tr>
          )}

          {!loading && !error && (!rows || rows.length === 0) && (
            <tr className="table__state">
              <td colSpan={columns.length}>{empty || 'Nothing here yet.'}</td>
            </tr>
          )}

          {!loading &&
            !error &&
            rows?.map((row, i) => (
              <tr
                key={getRowKey ? getRowKey(row) : i}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                className={onRowClick ? 'is-clickable' : undefined}
              >
                {columns.map((c) => (
                  <td key={c.key} className={c.align === 'right' ? 'is-right' : undefined}>
                    {c.render ? c.render(row) : row[c.key]}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
